/**
 * Inline error for a generation the Boost gate refused (T-312): says how many Boosts the
 * document needs when the server knew, and links to Buy Boosts unless billing is hidden.
 */

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Zap } from "lucide-react";
import { usePayment } from "../lib/PaymentContext";
import { publicRoutes } from "../lib/routes";
import type { InsufficientBoostsError } from "../services/naraDoor";

export default function BoostGateError({ error }: { error: InsufficientBoostsError }) {
  const { t } = useTranslation();
  const { billingHidden } = usePayment();

  const known = error.required !== undefined && error.balance !== undefined;
  const message = known
    ? t("billing.boostGate.needs", { count: error.required, balance: error.balance })
    : t("billing.boostGate.notEnough");

  return (
    <div
      role="alert"
      className="rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/50 p-4"
    >
      <p className="text-sm text-amber-800 dark:text-amber-200 mb-2">{message}</p>
      {!billingHidden && (
        <Link
          to={publicRoutes.billing}
          className="inline-flex items-center gap-1.5 rounded-lg bg-amber-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-amber-700 transition-colors"
        >
          <Zap className="h-4 w-4 shrink-0" />
          {t("billing.boostAlert.buy")}
        </Link>
      )}
    </div>
  );
}
